import API from "@vahak/core/dist/_services/const";
import { useVahakMutationQuery } from "@vahak/core/dist/hooks/useVahakQueryClient";
import useVahakHttpClient from "@vahak/core/dist/hooks/useVahakHttpClient";
import { QueryNames } from "@vahak/core/dist/_services/hooks/queryNames";
import { ApiErrorResponseType } from "@vahak/core/dist/custom-types/api-error-response-type";
import { CallInitiationParams } from "./callInitiationParams";

export type { CallInitiationParams } from "./callInitiationParams";
export { hasSingleCallCalleeId, withSingleCallParams } from "./callInitiationParams";

interface CallInitiationResponse {
    id?: number;
    call_count?: number;
    message?: string;
}

export const useCallInitiation = () => {
    const { POST } = useVahakHttpClient();

    const method = (data: CallInitiationParams) => {
        return POST<CallInitiationParams, CallInitiationResponse>(API.CALL_INITIATE, data);
    };
    return useVahakMutationQuery<CallInitiationResponse, ApiErrorResponseType, CallInitiationParams>(
        QueryNames.call.initiate,
        method
    );
};
